<template>
  <div v-if="program">
    <sticky v-if="!source" class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title" v-if="program">{{program.name | cap}} - Création d'un parking</span>
    </sticky>
    <div :class="{'columns is-gapless is-margin-left-on-btn-actions is-padding-top' : !source}">
      <div :class="{'column is-10 is-9-widescreen is-8-fullhd' : !source}">
        <div class="has-bg-white is-border">
          <parking-form v-if="program" @submit="submit" :source="parking" :program="program" :loading="loading"></parking-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round :isLoading="loading" v-else></spinner-round>
</template>


<script>
  import ParkingForm from '@/components/parking/ParkingForm'
  import { Error } from '@/mixins'

  export default {
    name: 'ParkingCreate',
    mixins: [Error],
    data () {
      return {
        loading: false,
        parking: null,
        program: null
      }
    },
    components: {
      ParkingForm
    },
    props: {
      source: Object
    },
    methods: {
      getParking (id) {
        this.loading = true
        this.$api.lotService.getOne(id).then(res => {
          this.parking = res.data
          this.getProgram(res.data.program)
        }).catch(() => {
          this.loading = false
        })
      },
      submit (parking) {
        this.loading = true
        this.$api.lotService.post(parking).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le parking a bien été créé'
          })
          this.$router.goBack(this.$route)
        }).catch((err) => {
          this.handleError(err, 'Erreur lors de l\'ajout du parking.')
          this.loading = false
        })
      },
      getProgram (programPk) {
        this.$api.programService.getOne(programPk).then(r => {
          this.program = r.data
          this.loading = false
        })
      }
    },
    created () {
      if (this.$route.query.duplicateParking) {
        this.getParking(this.$route.query.duplicateParking)
      } else if (this.source) {
        this.program = Object.assign({}, this.source)
      } else if (this.$route.query.program) {
        this.getProgram(this.$route.query.program)
      } else {
        this.$router.push({name: 'Forbidden'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/parking/ParkingCreate.vue